import Alpine from 'alpinejs';

Alpine.store('body', {
    scrollLocked: false
});
